import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { isAuthorizedAccess } from "./utils/helpers";
// import UnauthorizedAccess from "./pages/unauthorized-access";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ComponentList } from "./routing/componentlist";
import Quiz from "./pages/quiz";
import Login from "./pages/login";
import SignUp from "./pages/signup";
// import ResetPassword from "./pages/reset-password";
// import ForgotPassword from "./pages/forgot-password";
import Confirmation from "./pages/confirmation";
import Plan from "./pages/plan";

// import CancelSubscription from "./pages/cancel-subscription";
// import SignOut from "./pages/sign-out";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getGoogleClientId } from "./utils/general-config";
import Dashboard from "./pages/dashboard";
import ForgotPassword from "./pages/forgot-password";
import ResetPassword from "./pages/reset-password";
import Settings from "./pages/settings/";
import Processor from "./pages/processor";
import CareerPrecontent from "./pages/career-precontent";

import SignOut from "./pages/sign-out";
import AdminLogin from "./pages/admin-login";
import AdminSearch from "./pages/admin-search";
import QuizB from "./pages/quiz-b";
import LoginAsAdmin from "./pages/login-as-admin";

import PersonalityReport from "./pages/personality-report";
import CareerReport from "./pages/career-report";

import BigFiveReport from "./pages/big-five-report";
import BigFiveFacetsReport from "./pages/big-five-facets-report";
import EnneagramReport from "./pages/enneagram-report";
import LikeabilityReport from "./pages/likeability-report";
import PersonalityDisorderReport from "./pages/personality-disorder-report";
import DiscPersonalityReport from "./pages/disc-personality-report";
import ADHDReport from "./pages/adhd-report";
import CareerPreferenceReport from "./pages/career-preference-report";
import EmotionalIntelligenceReport from "./pages/emotional-intelligence-report";
import DifficultPersonReport from "./pages/difficult-person-report";
import AutismSpectrumReport from "./pages/autism-spectrum-report";
import HighlySensitivePersonReport from "./pages/highly-sensitive-person-report";
import AttachmentStyleReport from "./pages/attachment-style-report";
import CheckoutB from "./pages/checkout-b";

import DyslexiaScreeningChildrenReport from "./pages/dyslexia-screening-children-report";
import DyslexiaScreeningAdultReport from "./pages/dyslexia-screening-adult-report";
import LoveStyleReport from "./pages/love-style-report";
import NarcissisticPersonalityDisorderReport from "./pages/narcissistic-personality-disorder-report";
import AntisocialPersonalityDisorderReport from "./pages/antisocial-personality-disorder-report";
import CareerPreferencePrecontent from "./pages/career-preference-precontent";
import FourTemperamentPersonalityReport from "./pages/four-temperaments-personality-report";
import useLanguageCode from "./utils/language-code";
import CareerPreferenceReportV2 from "./pages/career-preference-report-v2";
import RomanticPersonalizedReport from "./pages/romantic-personalized-report";
import RomanticCompatibilityReport from "./pages/romantic-compatibility-report";
import ColorBlindReport from "./pages/color-blind-report";
import NotFound from "./pages/not-found";
import DepressionReport from "./pages/depression-report";

import BipolarDisorderReport from "./pages/bipolar-disorder-report";
import PsychopathyTestReport from "./pages/psychopathy-test-report";
import DashboardB from "./pages/dashboard-b";
import CheckoutC from "./pages/checkout-c";
import Checkout from "./pages/checkout";

const RenderRoutes = (props) => {
  const localtion = useLocation();
  const { pathname } = localtion;
  const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;
  // console.log("current-environment::", currentEnv);
  const navigate = useNavigate();
  const redirectfunnelStepRuleData = useSelector((state) => state.funnelStep);
  const { templateCd, currentStep } = redirectfunnelStepRuleData || {};
  const [showHome, setShowHome] = useState(false);
  useEffect(() => {
    setShowHome(true);
    if (localtion.pathname.indexOf("/en/") > -1) {
      const path = localtion.pathname.replaceAll("/en/", "/");
      return navigate(path);
    }
  }, []);

  useLanguageCode();

  return (
    <>
      <Routes>
        {/* {!isAuthorizedAccess() && <Route element={UnauthorizedAccess} />} */}

        <Route element={<Quiz />}>
          <Route
            path={ComponentList.RootHome.Path}
            element={showHome ? <Quiz /> : <></>}
          />
          <Route
            path={ComponentList.RootHome.LocalePath}
            element={showHome ? <Quiz /> : <></>}
          />
        </Route>
        {/* <Route exact path="/login" element={<Login />} /> */}

        {/* <Route element={<SignOut />}>
          <Route path={ComponentList.SignOut.Path} element={<SignOut />} />
          <Route
            path={ComponentList.SignOut.LocalePath}
            element={<SignOut />}
          />
        </Route> */}

        <Route element={<Quiz />}>
          <Route path={ComponentList.Quiz.Path} element={<Quiz />} />
          <Route path={ComponentList.Quiz.LocalePath} element={<Quiz />} />
        </Route>

        <Route
          element={
            <GoogleOAuthProvider clientId={getGoogleClientId()}>
              <Login />
            </GoogleOAuthProvider>
          }
        >
          <Route
            path={ComponentList.Login.Path}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <Login />
              </GoogleOAuthProvider>
            }
          />

          <Route element={<Login />}>
            <Route path={ComponentList.Login.Path} element={<Login />} />
            {/* <Route
            path={ComponentList.Confirmation.LocalePath}
            element={<Confirmation />}
          /> */}
          </Route>
          <Route
            path={ComponentList.Login.LocalePath}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <Login />
              </GoogleOAuthProvider>
            }
          />
        </Route>
        <Route
          element={
            <GoogleOAuthProvider clientId={getGoogleClientId()}>
              <SignUp />
            </GoogleOAuthProvider>
          }
        >
          <Route
            path={ComponentList.SignUp.Path}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignUp />
              </GoogleOAuthProvider>
            }
          />

          <Route
            path={ComponentList.SignUp.LocalePath}
            element={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignUp />
              </GoogleOAuthProvider>
            }
          />
        </Route>
        <Route element={<ResetPassword />}>
          <Route
            path={ComponentList.ResetPassword.Path}
            element={<ResetPassword />}
          />
          <Route
            path={ComponentList.ResetPassword.LocalePath}
            element={<ResetPassword />}
          />
        </Route>

        <Route element={<ForgotPassword />}>
          <Route
            path={ComponentList.ForgotPassword.Path}
            element={<ForgotPassword />}
          />
          <Route
            path={ComponentList.ForgotPassword.LocalePath}
            element={<ForgotPassword />}
          />
        </Route>
        <Route element={<Confirmation />}>
          <Route
            path={ComponentList.Confirmation.Path}
            element={<Confirmation />}
          />
          <Route
            path={ComponentList.Confirmation.LocalePath}
            element={<Confirmation />}
          />
        </Route>

        <Route element={<QuizB />}>
          <Route path={ComponentList.QuizB.Path} element={<QuizB />} />
          <Route path={ComponentList.QuizB.LocalePath} element={<QuizB />} />
        </Route>

        <Route element={<Plan />}>
          <Route path={ComponentList.Plan.Path} element={<Plan />} />
          <Route path={ComponentList.Plan.LocalePath} element={<Plan />} />
        </Route>
        <Route element={<Checkout />}>
          <Route path={ComponentList.Checkout.Path} element={<Checkout />} />
          <Route
            path={ComponentList.Checkout.LocalePath}
            element={<Checkout />}
          />
          {/* <Route
            path={ComponentList.Checkout.LocalePath}
            element={<Checkout />}
          /> */}
        </Route>

        <Route element={<CheckoutB />}>
          <Route path={ComponentList.CheckoutB.Path} element={<CheckoutB />} />
          <Route
            path={ComponentList.CheckoutB.LocalePath}
            element={<CheckoutB />}
          />
        </Route>

        <Route element={<CheckoutC />}>
          <Route path={ComponentList.CheckoutC.Path} element={<CheckoutC />} />
          <Route
            path={ComponentList.CheckoutC.LocalePath}
            element={<CheckoutC />}
          />
        </Route>

        <Route element={<Dashboard />}>
          <Route path={ComponentList.Dashboard.Path} element={<Dashboard />} />
          <Route
            path={ComponentList.Dashboard.LocalePath}
            element={<Dashboard />}
          />
        </Route>
        <Route element={<DashboardB />}>
          <Route
            path={ComponentList.DashboardB.Path}
            element={<DashboardB />}
          />
          <Route
            path={ComponentList.DashboardB.LocalePath}
            element={<DashboardB />}
          />
        </Route>
        <Route element={<Settings />}>
          <Route path={ComponentList.Settings.Path} element={<Settings />} />
          <Route
            path={ComponentList.Settings.LocalePath}
            element={<Settings />}
          />
        </Route>
        <Route element={<PersonalityReport />}>
          <Route
            path={ComponentList.Report.Path}
            element={<PersonalityReport />}
          />
          <Route
            path={ComponentList.Report.LocalePath}
            element={<PersonalityReport />}
          />
        </Route>

        <Route element={<Processor />}>
          <Route path={ComponentList.Processor.Path} element={<Processor />} />
        </Route>

        <Route element={<CareerPrecontent />}>
          <Route
            path={ComponentList.CareerPreContent.Path}
            element={<CareerPrecontent />}
          />
          <Route
            path={ComponentList.CareerPreContent.LocalePath}
            element={<CareerPrecontent />}
          />
        </Route>

        <Route element={<CareerReport />}>
          <Route
            path={ComponentList.CareerViewResult.Path}
            element={<CareerReport />}
          />
          <Route
            path={ComponentList.CareerViewResult.LocalePath}
            element={<CareerReport />}
          />
        </Route>

        <Route element={<SignOut />}>
          <Route path={ComponentList.SignOut.Path} element={<SignOut />} />
        </Route>

        <Route element={<QuizB />}>
          <Route path={ComponentList.QuizB.Path} element={<QuizB />} />
        </Route>
        <Route element={<AdminLogin />}>
          <Route
            path={ComponentList.AdminLogin.Path}
            element={<AdminLogin />}
          />
        </Route>

        <Route element={<LoginAsAdmin />}>
          <Route
            path={ComponentList.LoginAsAdmin.Path}
            element={<LoginAsAdmin />}
          />
        </Route>

        <Route element={<AdminSearch />}>
          <Route
            path={ComponentList.AdminSearch.Path}
            element={<AdminSearch />}
          />
        </Route>

        <Route element={<BigFiveReport />}>
          <Route
            path={ComponentList.BigFiveReport.Path}
            element={<BigFiveReport />}
          />
          <Route
            path={ComponentList.BigFiveReport.LocalePath}
            element={<BigFiveReport />}
          />
        </Route>
        <Route element={<BigFiveFacetsReport />}>
          <Route
            path={ComponentList.BigFiveFacetsReport.Path}
            element={<BigFiveFacetsReport />}
          />
          <Route
            path={ComponentList.BigFiveFacetsReport.LocalePath}
            element={<BigFiveFacetsReport />}
          />
        </Route>
        <Route element={<EnneagramReport />}>
          <Route
            path={ComponentList.EnneagramReport.Path}
            element={<EnneagramReport />}
          />
          <Route
            path={ComponentList.EnneagramReport.LocalePath}
            element={<EnneagramReport />}
          />
        </Route>

        <Route element={<LikeabilityReport />}>
          <Route
            path={ComponentList.LikeabilityReport.Path}
            element={<LikeabilityReport />}
          />
          <Route
            path={ComponentList.LikeabilityReport.LocalePath}
            element={<LikeabilityReport />}
          />
        </Route>

        <Route element={<PersonalityDisorderReport />}>
          <Route
            path={ComponentList.PersonalityDisorderReport.Path}
            element={<PersonalityDisorderReport />}
          />
          <Route
            path={ComponentList.PersonalityDisorderReport.LocalePath}
            element={<PersonalityDisorderReport />}
          />
        </Route>
        <Route element={<DiscPersonalityReport />}>
          <Route
            path={ComponentList.DiscPersonalityReport.Path}
            element={<DiscPersonalityReport />}
          />
          <Route
            path={ComponentList.DiscPersonalityReport.LocalePath}
            element={<DiscPersonalityReport />}
          />
        </Route>
        <Route element={<ADHDReport />}>
          <Route
            path={ComponentList.ADHDReport.Path}
            element={<ADHDReport />}
          />
          <Route
            path={ComponentList.ADHDReport.LocalePath}
            element={<ADHDReport />}
          />
        </Route>
        <Route element={<CareerPreferenceReport />}>
          <Route
            path={ComponentList.CareerPreferenceReport.Path}
            element={<CareerPreferenceReport />}
          />
          <Route
            path={ComponentList.CareerPreferenceReport.LocalePath}
            element={<CareerPreferenceReport />}
          />
        </Route>
        <Route element={<CareerPreferenceReportV2 />}>
          <Route
            path={ComponentList.CareerPreferenceReportV2.Path}
            element={<CareerPreferenceReportV2 />}
          />
          <Route
            path={ComponentList.CareerPreferenceReportV2.LocalePath}
            element={<CareerPreferenceReportV2 />}
          />
        </Route>
        <Route element={<EmotionalIntelligenceReport />}>
          <Route
            path={ComponentList.EmotionalIntelligenceReport.Path}
            element={<EmotionalIntelligenceReport />}
          />
          <Route
            path={ComponentList.EmotionalIntelligenceReport.LocalePath}
            element={<EmotionalIntelligenceReport />}
          />
        </Route>
        <Route element={<DifficultPersonReport />}>
          <Route
            path={ComponentList.DifficultPersonReport.Path}
            element={<DifficultPersonReport />}
          />
          <Route
            path={ComponentList.DifficultPersonReport.LocalePath}
            element={<DifficultPersonReport />}
          />
        </Route>
        <Route element={<AutismSpectrumReport />}>
          <Route
            path={ComponentList.AutismSpectrumReport.Path}
            element={<AutismSpectrumReport />}
          />
          <Route
            path={ComponentList.AutismSpectrumReport.LocalePath}
            element={<AutismSpectrumReport />}
          />
        </Route>

        <Route element={<HighlySensitivePersonReport />}>
          <Route
            path={ComponentList.HighlySensitivePersonReport.Path}
            element={<HighlySensitivePersonReport />}
          />
          <Route
            path={ComponentList.HighlySensitivePersonReport.LocalePath}
            element={<HighlySensitivePersonReport />}
          />
        </Route>
        <Route element={<AttachmentStyleReport />}>
          <Route
            path={ComponentList.AttachmentStyleReport.Path}
            element={<AttachmentStyleReport />}
          />
          <Route
            path={ComponentList.AttachmentStyleReport.LocalePath}
            element={<AttachmentStyleReport />}
          />
        </Route>

        <Route element={<DyslexiaScreeningChildrenReport />}>
          <Route
            path={ComponentList.DyslexiaScreeningChildrenReport.Path}
            element={<DyslexiaScreeningChildrenReport />}
          />
          <Route
            path={ComponentList.DyslexiaScreeningChildrenReport.LocalePath}
            element={<DyslexiaScreeningChildrenReport />}
          />
        </Route>

        <Route element={<DyslexiaScreeningAdultReport />}>
          <Route
            path={ComponentList.DyslexiaScreeningAdultReport.Path}
            element={<DyslexiaScreeningAdultReport />}
          />
          <Route
            path={ComponentList.DyslexiaScreeningAdultReport.LocalePath}
            element={<DyslexiaScreeningAdultReport />}
          />
        </Route>

        <Route element={<LoveStyleReport />}>
          <Route
            path={ComponentList.LoveStyleReport.Path}
            element={<LoveStyleReport />}
          />
          <Route
            path={ComponentList.LoveStyleReport.LocalePath}
            element={<LoveStyleReport />}
          />
        </Route>

        <Route element={<NarcissisticPersonalityDisorderReport />}>
          <Route
            path={ComponentList.NarcissisticPersonalityDisorder.Path}
            element={<NarcissisticPersonalityDisorderReport />}
          />
          <Route
            path={ComponentList.NarcissisticPersonalityDisorder.LocalePath}
            element={<NarcissisticPersonalityDisorderReport />}
          />
        </Route>
        <Route element={<AntisocialPersonalityDisorderReport />}>
          <Route
            path={ComponentList.AntisocialPersonalityDisorder.Path}
            element={<AntisocialPersonalityDisorderReport />}
          />
          <Route
            path={ComponentList.AntisocialPersonalityDisorder.LocalePath}
            element={<AntisocialPersonalityDisorderReport />}
          />
        </Route>
        <Route element={<CareerPreferencePrecontent />}>
          <Route
            path={ComponentList.CareerPreferencePrecontent.Path}
            element={<CareerPreferencePrecontent />}
          />
          <Route
            path={ComponentList.CareerPreferencePrecontent.LocalePath}
            element={<CareerPreferencePrecontent />}
          />
        </Route>
        <Route element={<FourTemperamentPersonalityReport />}>
          <Route
            path={ComponentList.FourTemperamentPersonalityReport.Path}
            element={<FourTemperamentPersonalityReport />}
          />
          <Route
            path={ComponentList.FourTemperamentPersonalityReport.LocalePath}
            element={<FourTemperamentPersonalityReport />}
          />
        </Route>

        <Route element={<RomanticPersonalizedReport />}>
          <Route
            path={ComponentList.RomanticPersonalityReport.Path}
            element={<RomanticPersonalizedReport />}
          />
          <Route
            path={ComponentList.RomanticPersonalityReport.LocalePath}
            element={<RomanticPersonalizedReport />}
          />
        </Route>

        <Route element={<RomanticCompatibilityReport />}>
          <Route
            path={ComponentList.RomanticCompatibilityReport.Path}
            element={<RomanticCompatibilityReport />}
          />
          <Route
            path={ComponentList.RomanticCompatibilityReport.LocalePath}
            element={<RomanticCompatibilityReport />}
          />
        </Route>
        <Route element={<ColorBlindReport />}>
          <Route
            path={ComponentList.ColorBlindReport.Path}
            element={<ColorBlindReport />}
          />
          <Route
            path={ComponentList.ColorBlindReport.LocalePath}
            element={<ColorBlindReport />}
          />
        </Route>
        <Route element={<DepressionReport />}>
          <Route
            path={ComponentList.DepressionReport.Path}
            element={<DepressionReport />}
          />
          <Route
            path={ComponentList.DepressionReport.LocalePath}
            element={<DepressionReport />}
          />
        </Route>
        <Route element={<BipolarDisorderReport />}>
          <Route
            path={ComponentList.BipolarDisorderReport.Path}
            element={<BipolarDisorderReport />}
          />
          <Route
            path={ComponentList.BipolarDisorderReport.LocalePath}
            element={<BipolarDisorderReport />}
          />
        </Route>

        <Route element={<PsychopathyTestReport />}>
          <Route
            path={ComponentList.PsychopathyTestReport.Path}
            element={<PsychopathyTestReport />}
          />
          <Route
            path={ComponentList.PsychopathyTestReport.LocalePath}
            element={<PsychopathyTestReport />}
          />
        </Route>

        {/* <Route element={<CancelSubscription />}>
          <Route
            path={ComponentList.CancelSubscription.Path}
            element={<CancelSubscription />}
          />
          <Route
            path={ComponentList.CancelSubscription.LocalePath}
            element={<CancelSubscription />}
          />
        </Route> */}
        {/* 404 Not Found route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};
export default RenderRoutes;
